import {RequiredRule, Validator} from 'devextreme-react/validator';
import {DateBox} from 'devextreme-react/date-box';
import {useContext} from 'react';
import {Field, Panel} from '../../../../layouts';
import {AR, OrderStatus} from '../../../../types/enums';
import {WorkOrderContext} from '../context/WorkOrderContext';

export default function CustomerContactDatePanel() {

	const { order, modifyOrder } = useContext(WorkOrderContext);

	const isOrderReadonly = order.details.orderStatusID === OrderStatus.Closed ||
		order.details.orderStatusID === OrderStatus.Cancelled;

	const isReadOnly = !order.details.activeARs.includes(AR.WOCfiToContactCustomer) || isOrderReadonly;
	const isRequired = !isReadOnly;

	return (
		<Panel header={'Dates'} >

			<Field label="Customer Contact Date" >
				<DateBox value={order.details.customerContactDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, customerContactDate: e.value })}
					readOnly={isReadOnly}
					max={new Date()}
					className={isRequired ? 'required' : ''}>
					<Validator>
						{isRequired && order.modified &&
							<RequiredRule message={'Customer Contact Date is required'} />}
					</Validator>
				</DateBox>
			</Field>
		</Panel>
	);
}
